import AllnewsModule from './containers/allnewsModule'

export {default as AllnewsModuleLayout} from './components/allnewsModuleLayout'

export default AllnewsModule
